<template>
  <v-layout :class="styles" v-if="!isEmpty">{{ feedbackMessage }}</v-layout>
</template>

<script>
import { css } from 'emotion'
import {
  getGoogleFeedbackMessage,
  getXDFeedbackMessage,
} from '@/models/Creative'

export default {
  name: 'CreativeAuditFeedback',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    isEmpty() {
      return this.value === '' || this.value == null
    },
    feedbackMessage() {
      const originMessage = this.value
      const fallBackMessage = `${originMessage} 詳しくはお問い合わせ下さい。`
      const message =
        getGoogleFeedbackMessage(originMessage) ||
        getXDFeedbackMessage(originMessage)
      return message ? message.ja : fallBackMessage
    },
    styles() {
      return [
        css`
          font-size: 12px;

          &::before {
            content: '詳細';
            display: block;
            width: 40px;
            height: 20px;
            white-space: nowrap;
            margin-right: 8px;
          }
        `,
        'grey--text',
      ]
    },
  },
}
</script>

<style></style>
